module.exports = __webpack_public_path__ + "media/images/arrows/default-e0478a62c4caee8c122ae8942f9d212d.svg";